import { Container } from 'src/components/common/Container'
import styled from 'styled-components'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16, Noto_body2_b14, Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'

const GiftRefundInfoConfirmModal = ({
  refundInfoText,
  price,
}: {
  refundInfoText: string
  price: number
}) => {
  return (
    <>
      <Typography $fontStyle={Noto_body1_r16} $color="var(--black-100)">
        입력한 정보를 확인해주세요.
        <br />
        제출 이후 수정이 어렵습니다.
      </Typography>
      <S.GiftInfoContainer $option="flex_column" $row_gap="10px">
        <S.RefundInfo $fontStyle={Noto_body2_r14}>{refundInfoText}</S.RefundInfo>
        <Typography $fontStyle={Noto_body2_b14}>환불금액 : {price?.toLocaleString()}원</Typography>
      </S.GiftInfoContainer>
    </>
  )
}
export default GiftRefundInfoConfirmModal

const S = {
  GiftInfoContainer: styled(Container)`
    margin: 10px 0 26px;
    padding: 12px 10px;
    border-radius: 12px;
    background-color: var(--black-4);
    text-align: center;
    color: var(--black-70);
  `,
  RefundInfo: styled(Typography)`
    white-space: pre-line;
  `,
}
